import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowPathLeft"><Path d="M9.34596 4.33737C9.99374 3.77713 11.0001 4.2373 11.0001 5.09374V8.00024H19.5001C20.8808 8.00024 22.0001 9.11953 22.0001 10.5002V13.5002C22.0001 14.881 20.8808 16.0002 19.5001 16.0002H11.0001V18.9068C11.0001 19.7632 9.99374 20.2234 9.34596 19.6631L1.79758 13.1348C1.10588 12.5366 1.10589 11.4639 1.79758 10.8657L9.34596 4.33737Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathLeft;
